<template>
    <div class="quiz-bottom-wrapper tw-relative tw-border-t-2 tw-border-gray-100 tw-bg-gray-0 tw-z-20">
        <transition v-if="quizSettings.direct_feedback === '1'" name="slide-up" appear>
            <div class="answer-feedback tw-absolute tw-mx-4 tw-w-auto tw-text-center tw-left-0 tw-right-0" v-if="answer_confirmed.is_confirmed && answer_confirmed.display">
                <div class="tw-py-4 tw-px-6 tw-text-left tw-rounded-lg tw-shadow-light tw-text-white tw-cursor-pointer hover:tw-opacity-75 tw-inline-block" :class="answer_confirmed.is_correct ? 'tw-bg-green-400' : 'tw-bg-red-400'">
                    <template v-if="!answer_confirmed.is_correct">
                        <div class="answer-feedback-item tw-flex tw-items-center tw-text-lg">
                            <i class="fa fa-times tw-pr-2"></i>
                            <h3 class="tw-font-bold">{{ translations['quiz.wrong_answer'] }}</h3>
                        </div>
                        <template v-if="quizSettings.correct_answer_feedback === '1'">
                            <p class="tw-pt-3 tw-pb-2"><b>{{ translations['quiz.given_answer'] }}:</b> {{ given_answer }}</p>
                            <p class="tw-pt-2"><b>{{ translations['quiz.correct_answer'] }}:</b> {{ correct_answer }}</p>
                        </template>
                    </template>
                    <template v-else>
                        <div class="answer-feedback-item tw-flex tw-items-center tw-text-lg">
                            <i class="fa fa-check tw-pr-2"></i>
                            <h3 class="tw-font-bold tw-py-2 tw-leading-none ">{{ translations['quiz.correct_answer'] }}!</h3>
                        </div>
                    </template>
                </div>
            </div>
        </transition>
        <div class="quiz-bottom tw-pb-4 tw-pt-4 tw-bg-gray-0 tw-relative tw-h-full">
            <div class="quiz-btn-wrapper tw-mx-auto">
                <div class="tw-btn tw-shadow-light" v-if="!quiz_started" @click="startQuiz()" :class="{'tw-opacity-50': starting_quiz}">{{ translations['quiz.start'] }}</div>
                <template v-else>
                    <template v-if="timer_passed">
                        <div class="tw-btn tw-btn-gray tw-shadow-light" v-if="quizSettings.retry === '1'" @click="resetQuiz">{{ translations['quiz.retry'] }}</div>
                    </template>
                    <template v-else-if="!lastQuestion && !display_quiz_ended">
                        <div class="tw-btn tw-shadow-light" v-if="!answer_confirmed.is_confirmed || quizSettings.direct_feedback === '0'" :class="{'tw-opacity-50': confirming_answer || answerDisabled}" @click="confirmQuestion(false)">{{ translations['quiz.confirm_answer'] }}</div>
                        <div class="tw-btn tw-shadow-light" v-else @click="toNextQuestion">{{ translations['quiz.next_question'] }}</div>
                    </template>
                    <template v-else>
                        <div class="tw-btn tw-shadow-light" v-if="!answer_confirmed.is_confirmed && !display_quiz_ended" :class="{'tw-opacity-50': confirming_answer || answerDisabled}" @click="confirmQuestion(true)">{{ translations['quiz.confirm_answer'] }}</div>
                        <div class="tw-btn tw-shadow-light" v-else-if="!display_quiz_ended && !timer_passed" @click="endQuiz">{{ translations['quiz.finish'] }}</div>
                        <div class="tw-btn tw-btn-gray tw-shadow-light" v-else-if="quizSettings.retry === '1'" @click="resetQuiz">{{ translations['quiz.retry'] }}</div>
                        <div class="tw-btn tw-btn-gray tw-btn-disabled tw-disabled tw-shadow-light" v-else>{{ translations['quiz.finished'] }}</div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import Global  from '../../../mixins/Global.js';

let _ = require('lodash');

export default {
	mixins: [Global],
	name: 'QuestionBottom',

	props: ['questions', 'active_question', 'display_quiz_ended', 'timer_passed', 'course_id'],

	data() {
		return {
			confirming_answer: false,
			starting_quiz: false,
		};
	},

	computed: {
		...mapState('quiz',
			['quiz', 'quiz_started', 'current_question_index', 'answer_confirmed', 'response_id', 'new_answer', 'quiz_finished', 'quizSettings', 'current_answer']
		),

		lastQuestion() {
			return this.current_question_index+1 === this.questions.length;
		},

		correct_answer() {
			if (this.questions[this.current_question_index].type === 'true_false') {
				return this.answer_confirmed.correct_answer === false ? this.translations['quiz.false'] : this.translations['quiz.true'];
			} else if (this.questions[this.current_question_index].type === 'free_form') {
				return this.answer_confirmed.correct_answer;
			} else {
				return this.$store.getters['quiz/getQuestionOptionById'](this.answer_confirmed.correct_answer).value;
			}
		},

		given_answer() {
			const answer = this.$store.getters['quiz/getQuestionProgress'](this.active_question.id);

			if (typeof answer !== 'undefined') {
				if (this.active_question.type === 'free_form') {
					return answer.value;
				} else if (this.active_question.type === 'true_false') {
					return answer.value == '0' ? 'false' : 'true';
				} else {
					return answer.question_options.value;
				}
			} else {
				if (this.active_question.type === 'free_form') {
					return this.new_answer.value;
				} else if (this.active_question.type === 'true_false') {
					return this.new_answer.value == '0' ? 'false' : 'true';
				} else {
					return this.$store.getters['quiz/getQuestionOptionById'](this.new_answer.question_option_id).value;
				}
			}
		},

		answerDisabled() {
			return this.current_answer === null && typeof this.$store.getters['quiz/getQuestionProgress'](this.active_question.id) === 'undefined';
		},
	},

	methods: {
		...mapMutations('quiz',[
			'resetQuiz'
		]),

		confirmQuestion(finish = false) {
			if (!this.confirming_answer) {
				if (typeof this.$store.getters['quiz/getQuestionProgress'](this.active_question.id) === 'undefined') {
					this.confirming_answer = true;

					if (!this.answerDisabled) {
						const answer = this.$store.getters['quiz/getQuestionProgress'](this.active_question.id);
						let answer_value = false;

						if (typeof answer !== 'undefined') {
							if (this.active_question.type === 'true_false' || this.active_question.type === 'free_form') {
								answer_value = answer.value;
							} else {
								answer_value = answer.question_option_id;
							}
						} else {
							if (this.active_question.type === 'true_false' || this.active_question.type === 'free_form') {
								answer_value = this.new_answer.value;
							} else {
								answer_value = this.new_answer.question_option_id;
							}
						}

						let formData = {
							'quiz_id': this.quiz.id,
							'user_id': this.user.id,
							'response_id': this.response_id,
							'responses': [
								{
									'question_id': this.active_question.id,
									'question_option_id': answer_value,
									'answer': answer_value,
								}
							],
							'is_finished': finish,
							'course_id': this.course_id,
						};

						//post the answer
						this.$store.dispatch('quiz/postAnswer', formData).then((response) => {
							if (finish) {
								const score = response.data.data.score;

								if (score) {
									this.$store.commit('quiz/setFinalScore', score);
								}
							}

							//then update the progress
							this.$store.dispatch('quiz/getCurrentProgress', true).then(() => {
								this.confirming_answer = false;

								//if we dont want to show the feedback, move on to the next answer
								if(this.quizSettings.direct_feedback !== '1') {
									if(!this.lastQuestion) {
										this.toNextQuestion();
									} else {
										this.endQuiz();
									}
								} else {
									//confirm the answer and show its results
									this.commitAnswer();
								}
							});
						});
					} else {
						this.confirming_answer = false;
					}
				} else {
					this.toNextQuestion();
				}
			}
		},

		endQuiz() {
			this.confirming_answer = false;
			this.dismissFeedback();

			this.$store.commit('quiz/endQuiz');
		},

		dismissFeedback() {
			this.$store.commit('quiz/dismissAnswerFeedback');
		},

		toNextQuestion(){
			if(this.quiz_finished) {
				if(!this.display_quiz_ended) {
					this.$store.commit('quiz/navigateQuestion', 1);
				}

				this.$nextTick(() => {
					this.$store.commit('quiz/toggleQuizEndDisplay', false);

					//confirm the answer and show its results
					this.commitAnswer();
				});
			} else {
				this.$store.commit('quiz/navigateQuestion', 1);

				//if an answer already was given, we commit it
				this.$nextTick(() => {
					this.commitAnswer();
				});
			}
		},

		commitAnswer() {
			let given_answer = this.$store.getters['quiz/getQuestionProgress'](this.active_question.id);

			if(given_answer) {
				if(this.active_question.type === 'true_false' || this.active_question.type === 'free_form') {
					this.$store.commit('quiz/confirmAnswer', {is_correct: given_answer.is_correct, correct_answer: given_answer.correct_answer});
				} else {
					this.$store.commit('quiz/confirmAnswer', {is_correct: given_answer.is_correct, correct_answer: given_answer.correct_question_option_id});
				}
			}
		},

		startQuiz(){
			if (!this.starting_quiz) {
				this.starting_quiz = true;

				this.$store.dispatch('quiz/startQuiz', true).then(() => {
					this.starting_quiz = false;
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
    .quiz-wrapper {
        .quiz-btn-wrapper {
            width: 65%;

			.tw-btn.tw-opacity-50 {
				&:hover {
					opacity: 0.5 !important;
				}
			}
        }

        .answer-feedback {
            bottom: 100px;

            .answer-feedback-item {
                h3 {
                    color: inherit !important;
                    margin: 0;
                }
            }
        }
    }

    //popup slide up
    .slide-up-enter-active {
        transition: bottom 0.15s cubic-bezier(0, 0, 0.2, 1), opacity 0.15s cubic-bezier(0, 0, 0.2, 1);
    }

    .slide-up-enter, .slide-up-leave-to {
        bottom: 0 !important;
        opacity: 0 !important;
    }

    .slide-up-enter-to, .slide-up-leave {
        bottom: 100px !important;
        opacity: 0.9 !important;
    }
</style>